import { transformSavedFilterGroups } from 'components/filter/filters-next/downstream';
import { getFilterCounts } from 'components/filter/filters-next/util';
import { OutboundFilters } from 'types/request';

interface RecipientFiltersProps {
    filters: OutboundFilters;
}

const RecipientFilters = ({ filters }: RecipientFiltersProps) => {
    const { filtersCountReadable } = getFilterCounts(transformSavedFilterGroups(filters));

    return <p>{filtersCountReadable}</p>;
};

export { RecipientFilters };
